import React, { Component } from "react";
import {
  Modal,
  Form,
  Col,
  Row
} from "react-bootstrap";

import * as Cookies from "es-cookie";
import SelectDropDown from "../selectdropdown/SelectDropDown";

import "./_educationManagementStudents.scss";

// Classes that require a stream selection — Class 11 (id 1) and Class 12 (id 2),
// i.e. Intermediate 1st/2nd year.
const STREAM_CLASS_IDS = [1, 2];
const isStreamClass = (classId) => STREAM_CLASS_IDS.includes(parseInt(classId));

// A date-input needs YYYY-MM-DD. admitted_date is a `timestamp` column that arrives as unix
// seconds (e.g. 1784118371); dob arrives as YYYY-MM-DD. Normalise either to YYYY-MM-DD.
const toDateInput = (v) => {
  if (!v || v === "-") return "";
  const s = String(v).trim();
  const iso = /^(\d{4}-\d{2}-\d{2})/.exec(s);
  if (iso) return iso[1];
  let d = null;
  if (/^\d{10}$/.test(s)) d = new Date(Number(s) * 1000);
  else if (/^\d{13}$/.test(s)) d = new Date(Number(s));
  else { const p = new Date(s); if (!isNaN(p.getTime())) d = p; }
  if (d && !isNaN(d.getTime())) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  }
  return "";
};

class EditDetailsModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showParentPassword: false,
      showStudentPassword: false,

      // IMAGE
      profileImageBase: "",
      newProfileImageBase64: "",
      removeProfile: false,

      // STUDENT
      studentName: "",
      studentMobile: "",
      admissionNo: "",
      rollNo: "",
      dob: "",
      gender: "",
      adharNo: "",
      penNo: "",
      admittedDate: "",
      branchId: 0,
      classId: 0,
      streamId: 0,
      sectionId: 0,
      branchName: "",
      className: "",
      sectionName: "",
      studentNameError: "",
      studentMobileError: "",
      rollNoError: "",
      sectionIdError: "",
      streamIdError: "",
      studentNameSuccess: false,
      passwordSuccess: false,

      // PARENT
      parentName: "",
      parentMobile: "",
      parentPassword: "",
      studentPassword: "",
      fatherName: "",
      fatherPhone: "",
      motherName: "",
      motherPhone: "",

      // ERRORS
      parentNameError: "",
      parentMobileError: "",
      parentPasswordError: "",
      studentPasswordError: "",
      fatherPhoneError: "",
      motherPhoneError: "",

      loadingSpinner: 0,
      isSubmitting: false,
      currentStep: 0,
      submitError: ""
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      const rowData = this.props.stateData?.rowData || {};
      const stateData = this.props.stateData || {};

      this.setState({
        showParentPassword: false,
        showStudentPassword: false,
        currentStep: 0,
        submitError: "",
        isSubmitting: false,
        loadingSpinner: 0,

        parentNameError: "",
        parentMobileError: "",
        parentPasswordError: "",
        studentPasswordError: "",

        profileImageBase: rowData.profile_image_base || rowData.profile_image || "",
        newProfileImageBase64: "",
        removeProfile: false,

        studentName: rowData.student_name || "-",
        studentMobile: rowData.contact_no || "-",
        admissionNo: rowData.admission_no || "-",
        rollNo: rowData.roll_no || "-",
        dob: rowData.dob || "-",
        gender: rowData.gender || "-",
        adharNo: rowData.adhar_no || "",
        penNo: rowData.pen_no || "",
        admittedDate: toDateInput(rowData.admitted_date),
        branchId: rowData.branch || 0,
        classId: rowData.class || 0,
        streamId: rowData.stream || 0,
        sectionId: rowData.section || 0,
        branchName: rowData.branch_name || "-",
        className: rowData.class_name || "-",
        sectionName: rowData.section_name || "-",
        studentNameError: "",
        rollNoError: "",
        sectionIdError: "",
        streamIdError: "",
        studentNameSuccess: false,
        passwordSuccess: false,

        parentName: stateData.parentName || "",
        parentMobile: stateData.parentMobile || "",
        parentPassword: stateData.parentPassword || "",
        studentPassword: "",
        fatherName: rowData.father_name && rowData.father_name !== "-" ? rowData.father_name : "",
        fatherPhone: rowData.father_phone && rowData.father_phone !== "-" ? rowData.father_phone : "",
        motherName: rowData.mother_name && rowData.mother_name !== "-" ? rowData.mother_name : "",
        motherPhone: rowData.mother_phone && rowData.mother_phone !== "-" ? rowData.mother_phone : "",
      });
    }
  }

  handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const MAX_WIDTH = 250;
          const MAX_HEIGHT = 250;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          // Compress image to JPEG at 70% quality to keep Base64 size well under 64KB
          const compressedBase64 = canvas.toDataURL("image/jpeg", 0.7);
          this.setState({ newProfileImageBase64: compressedBase64, removeProfile: false });
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    }
  };

  handleImageRemove = (e) => {
    if (e) e.preventDefault();
    // Clear the shown image and flag removal so submit clears it in the DB.
    this.setState({ newProfileImageBase64: "", profileImageBase: "", removeProfile: true });
  };

  handleInputChange = (e) => {
    let { name, value } = e.target;

    // Allow only 10 digits for mobile numbers
    if (
      name === "parentMobile" ||
      name === "fatherPhone" ||
      name === "motherPhone"
    ) {
      value = value.replace(/\D/g, "").slice(0, 10);
    }

    this.setState({
      [name]: value,
      [`${name}Error`]: "",
    });

    if (name === "parentMobile") {
      if (value && value.length !== 10) {
        this.setState({
          parentMobileError: "Enter valid 10 digit mobile number",
        });
      }
    }

    if (name === "fatherPhone" || name === "motherPhone") {
      if (value && value.length !== 10) {
        this.setState({
          [`${name}Error`]: "Enter valid 10 digit mobile number",
        });
      }
    }

  };

  handleSelectChange = (name, value) => {
    // Changing branch invalidates class/stream/section (they're branch-specific).
    if (name === "branchId") {
      this.setState({ branchId: value, classId: 0, streamId: 0, sectionId: 0, streamIdError: "", sectionIdError: "" });
      return;
    }
    // Changing class invalidates the chosen stream + section.
    if (name === "classId") {
      this.setState({ classId: value, streamId: 0, sectionId: 0, streamIdError: "", sectionIdError: "" });
      return;
    }
    // Changing the stream only invalidates the section when the currently
    // selected section doesn't belong to the new stream — keep the existing
    // section value otherwise (don't wipe it on load / same-stream re-selects).
    if (name === "streamId") {
      const branch = this.props.stateData?.branches?.find(
        (b) => String(b.id) === String(this.state.branchId)
      );
      const sections = branch ? (branch.sections || []) : [];
      const currentSection = sections.find((s) => String(s.id) === String(this.state.sectionId));
      const keepSection = currentSection && String(currentSection.stream_id) === String(value);
      this.setState({
        streamId: value,
        streamIdError: "",
        sectionId: keepSection ? this.state.sectionId : 0,
        sectionIdError: "",
      });
      return;
    }
    this.setState({ [name]: value, [`${name}Error`]: "" });
  };

  validateParentForm = () => {
    let isValid = true;
    const errors = {};
    const mobileRegex = /^[0-9]{10}$/;

    if (!this.state.parentName.trim()) {
      errors.parentNameError = "Parent name is required";
      isValid = false;
    }

    if (!this.state.parentMobile) {
      errors.parentMobileError = "Mobile number is required";
      isValid = false;
    } else if (!mobileRegex.test(this.state.parentMobile)) {
      errors.parentMobileError = "Enter valid 10 digit mobile number";
      isValid = false;
    }

    if (!this.state.parentPassword) {
      errors.parentPasswordError = "Password is required";
      isValid = false;
    }

    this.setState(errors);
    return isValid;
  };

  handleFormSubmit = async () => {
    this.setState({
      submitError: "",
      studentNameSuccess: false,
      passwordSuccess: false,
      currentStep: 0,
      studentNameError: "",
      studentMobileError: "",
      rollNoError: "",
      sectionIdError: "",
      streamIdError: "",
      parentPasswordError: "",
      studentPasswordError: "",
      fatherPhoneError: "",
      motherPhoneError: ""
    });

    let hasError = false;
    const errors = {};

    if (!this.state.studentName.trim()) {
      errors.studentNameError = "Student name is required";
      hasError = true;
    }
    if (this.state.studentMobile && this.state.studentMobile !== "-" && !/^[0-9]{10}$/.test(this.state.studentMobile)) {
      errors.studentMobileError = "Enter valid 10 digit mobile number";
      hasError = true;
    }
    if (!this.state.rollNo.trim()) {
      errors.rollNoError = "Roll No is required";
      hasError = true;
    }
    if (!this.state.sectionId || parseInt(this.state.sectionId) === 0) {
      errors.sectionIdError = "Section is required";
      hasError = true;
    }
    // if (isStreamClass(this.state.classId) && (!this.state.streamId || parseInt(this.state.streamId) === 0)) {
    //   errors.streamIdError = "Stream is required";
    //   hasError = true;
    // }
    if (this.state.fatherPhone && !/^[0-9]{10}$/.test(this.state.fatherPhone)) {
      errors.fatherPhoneError = "Enter valid 10 digit mobile number";
      hasError = true;
    }
    if (this.state.motherPhone && !/^[0-9]{10}$/.test(this.state.motherPhone)) {
      errors.motherPhoneError = "Enter valid 10 digit mobile number";
      hasError = true;
    }

    if (hasError) {
      this.setState(errors);
      return;
    }

    this.setState({ isSubmitting: true, loadingSpinner: 1 });
    try {
      const params = {
        edu_student_id: parseInt(this.props.stateData?.edu_student_id) || 0,
        student_user_id: parseInt(this.props.stateData?.student_user_id) || 0,
        institute_id: parseInt(Cookies.get("institutionid")) || 0,
        student_name: this.state.studentName,
        student_mobile: this.state.studentMobile && this.state.studentMobile !== "-" ? this.state.studentMobile.toString() : "",
        admission_no: this.state.admissionNo && this.state.admissionNo !== "-" ? this.state.admissionNo.toString() : "",
        roll_no: this.state.rollNo,
        class_id: parseInt(this.state.classId) || 0,
        stream_id: isStreamClass(this.state.classId) ? (parseInt(this.state.streamId) || 0) : 0,
        branch_id: parseInt(this.state.branchId) || 0,
        section_id: parseInt(this.state.sectionId) || 0,
        father_name: this.state.fatherName,
        father_phone: this.state.fatherPhone ? this.state.fatherPhone.toString() : "",
        mother_name: this.state.motherName,
        mother_phone: this.state.motherPhone ? this.state.motherPhone.toString() : "",
        // Only send a real YYYY-MM-DD date; otherwise null so the DATEONLY column isn't fed "Invalid date"/"-"
        dob: /^\d{4}-\d{2}-\d{2}$/.test(this.state.dob) ? this.state.dob : null,
        gender: (this.state.gender === "Boy" || this.state.gender === "Girl") ? this.state.gender : null,
        adhar_no: this.state.adharNo && this.state.adharNo !== "-" ? this.state.adharNo.toString().trim() : "",
        pen_no: this.state.penNo && this.state.penNo !== "-" ? this.state.penNo.toString().trim() : "",
        admitted_date: /^\d{4}-\d{2}-\d{2}$/.test(this.state.admittedDate) ? this.state.admittedDate : null,
        parent_password: this.state.parentPassword ? this.state.parentPassword : "",
        student_password: this.state.studentPassword ? this.state.studentPassword : "",
      };
      await this.props.onEditEduStudent(params);

      if (this.state.newProfileImageBase64 || this.state.removeProfile) {
        await this.props.onAddProfileImage({
          profile_image: "",
          // Removed → send empty base to clear it; otherwise the new upload.
          profile_image_base: this.state.removeProfile ? "" : this.state.newProfileImageBase64,
          user_id: 0,
          institute_id: parseInt(Cookies.get("institutionid")),
          type: "student",
          edu_student_id: parseInt(this.props.stateData?.edu_student_id) || 0,
          student_user_id: parseInt(this.props.stateData?.student_user_id) || 0
        });
      }

      this.setState({ loadingSpinner: 0, isSubmitting: false });
      this.props.onHide();
    } catch (error) {
      this.setState({
        loadingSpinner: 0,
        isSubmitting: false,
        submitError: error?.graphQLErrors?.[0]?.message || "Failed to update details.",
      });
    }
  };

  sortSectionsByName = (sections) =>
    [...(sections || [])].sort((a, b) =>
      String(a.value ?? "").localeCompare(
        String(b.value ?? ""),
        undefined,
        { sensitivity: "base", numeric: true }
      )
    );


  sortClassesByName = (classes) =>
    [...(classes || [])].sort((a, b) =>
      String(a.value ?? "").localeCompare(
        String(b.value ?? ""),
        undefined,
        { sensitivity: "base", numeric: true }
      )
    );

  render() {
    console.log("this", this.state);

    const selectedBranchData = this.props.stateData?.branches?.find(
      (b) => String(b.id) === String(this.state.branchId)
    );

    // Branch options (so Branch is editable too).
    const branchArr = (this.props.stateData?.branches || []).map((b) => ({
      value: b.id,
      label: b.branch_name,
      id: b.id,
    }));


    // Iterate getClasses (already sorted by order_no from getExamClasses) filtered
    // to this branch's classes, so the dropdown follows order_no — matching Add.
    const sectionClassIds = new Set((selectedBranchData?.sections || []).map((s) => String(s.class_id)));
    const classArr = selectedBranchData
      ? (this.props?.stateData?.getClasses || [])
        .filter((c) => sectionClassIds.has(String(c.id)))
        .map((c) => ({ value: c.id, label: c.class, id: c.id }))
      : [];

    // Streams available for this branch+class are derived from the sections'
    // stream_id, mapped to names via the stream master (props.streams).
    const streamMaster = this.props.streams || [];
    const streamArr = selectedBranchData
      ? [...new Set(
        selectedBranchData.sections
          .filter((s) => String(s.class_id) === String(this.state.classId) && s.stream_id)
          .map((s) => s.stream_id)
      )]
        .map((sid) => {
          const st = streamMaster.find((m) => String(m.id) === String(sid));
          return st ? { value: st.id, label: st.stream } : null;
        })
        .filter(Boolean)
      : [];

    const sectionArr = selectedBranchData
      ? this.sortSectionsByName(
        selectedBranchData.sections
          .filter(
            (s) =>
              !this.state.classId ||
              String(s.class_id) === String(this.state.classId)
          )
          // For stream classes, restrict sections to the selected stream
          .filter(
            (s) =>
              !isStreamClass(this.state.classId) ||
              !this.state.streamId ||
              String(s.stream_id) === String(this.state.streamId)
          )
          .map((s) => ({
            value: s.id,
            label: s.section_name,
            class_id: s.class_id,
            id: s.id,
          }))
      )
      : [];

    return (

      <Modal
        {...this.props}
        size="lg"
        centered
        className="edu-custom-modal"
      >

        {/* HEADER */}
        <Modal.Header closeButton className="edu-modal-header">
          <Modal.Title>
            <span className="edu-header-dot"></span>
            Edit Student Details
          </Modal.Title>
        </Modal.Header>

        {/* BODY */}
        <Modal.Body className="edu-modal-body">

          {(this.state.studentNameSuccess || this.state.passwordSuccess) && (
            <div className="edu-alert-success">
              <i className="fas fa-check-circle mr-2"></i>
              Details updated successfully!
            </div>
          )}

          {this.state.submitError && (
            <div className="edu-alert-danger">
              <i className="fas fa-exclamation-circle mr-2"></i>
              {this.state.submitError}
            </div>
          )}

          {/* CARD 1: Student Details */}
          <div className="edu-details-card">
            <div className="edu-details-card__header">
              <h5 className="edu-details-card__title">
                <i className="fas fa-user-graduate"></i> Student Details
              </h5>
            </div>

            <Row>
              <Col sm={12} className="mb-4 d-flex flex-column align-items-center justify-content-center">
                <div className="edu-profile-upload-wrapper" style={{ position: "relative", width: 100, height: 100, borderRadius: "50%", border: "2px dashed #d1d5db", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", backgroundColor: "#f9fafb", cursor: "pointer" }}>
                  {this.state.newProfileImageBase64 || this.state.profileImageBase ? (
                    <img
                      src={this.state.newProfileImageBase64 || this.state.profileImageBase}
                      alt="Profile"
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  ) : (
                    <i className="fas fa-camera" style={{ fontSize: 24, color: "#9ca3af" }}></i>
                  )}
                  <div className="edu-profile-upload-overlay" style={{ position: "absolute", bottom: 0, left: 0, right: 0, background: "rgba(0,0,0,0.5)", color: "#fff", fontSize: 10, textAlign: "center", padding: "4px 0", opacity: 0, transition: "opacity 0.2s" }}>
                    Upload
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={this.handleImageChange}
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer" }}
                  />
                </div>
                {(this.state.newProfileImageBase64 || this.state.profileImageBase) ? (
                  <button type="button" onClick={this.handleImageRemove} style={{ marginTop: 8, background: "transparent", border: "none", color: "#dc2626", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                    <i className="fal fa-times-circle mr-1" />Remove photo
                  </button>
                ) : null}
              </Col>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Student Name</Form.Label>
                <Form.Control
                  className="edu-input"
                  type="text"
                  name="studentName"
                  value={this.state.studentName}
                  onChange={this.handleInputChange}
                />
                {this.state.studentNameError && (
                  <div className="edu-error">{this.state.studentNameError}</div>
                )}
              </Form.Group>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Contact No</Form.Label>
                <Form.Control
                  className="edu-input"
                  type="text"
                  name="studentMobile"
                  value={this.state.studentMobile}
                  onChange={this.handleInputChange}
                />
                {this.state.studentMobileError && (
                  <div className="edu-error">{this.state.studentMobileError}</div>
                )}
              </Form.Group>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Roll No</Form.Label>
                <Form.Control
                  className="edu-input"
                  type="text"
                  name="rollNo"
                  value={this.state.rollNo}
                  onChange={this.handleInputChange}
                />
                {this.state.rollNoError && (
                  <div className="edu-error">{this.state.rollNoError}</div>
                )}
              </Form.Group>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Admission No</Form.Label>
                <Form.Control
                  className="edu-input"
                  type="text"
                  name="admissionNo"
                  value={this.state.admissionNo}
                  onChange={this.handleInputChange}
                />
              </Form.Group>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Date of Birth</Form.Label>
                <Form.Control
                  className="edu-input"
                  type="date"
                  name="dob"
                  value={this.state.dob && this.state.dob !== "-" ? this.state.dob : ""}
                  onChange={this.handleInputChange}
                />
              </Form.Group>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Aadhaar No</Form.Label>
                <Form.Control
                  className="edu-input"
                  type="text"
                  name="adharNo"
                  maxLength={12}
                  placeholder="Aadhaar number"
                  value={this.state.adharNo && this.state.adharNo !== "-" ? this.state.adharNo : ""}
                  onChange={this.handleInputChange}
                />
              </Form.Group>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">PEN No</Form.Label>
                <Form.Control
                  className="edu-input"
                  type="text"
                  name="penNo"
                  placeholder="PEN number"
                  value={this.state.penNo && this.state.penNo !== "-" ? this.state.penNo : ""}
                  onChange={this.handleInputChange}
                />
              </Form.Group>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Admitted Date</Form.Label>
                <Form.Control
                  className="edu-input"
                  type="date"
                  name="admittedDate"
                  value={this.state.admittedDate && this.state.admittedDate !== "-" ? this.state.admittedDate : ""}
                  onChange={this.handleInputChange}
                />
              </Form.Group>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Gender</Form.Label>
                <SelectDropDown
                  name="gender"
                  placeholderName="Select Gender"
                  options={[
                    { value: "Boy", label: "Boy" },
                    { value: "Girl", label: "Girl" }
                  ]}
                  stateData={[
                    { value: "Boy", label: "Boy" },
                    { value: "Girl", label: "Girl" },
                  ].find((opt) => String(opt.value).toLowerCase() === String(this.state.gender).toLowerCase()) || null}
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                />
              </Form.Group>

              <Form.Group as={Col} lg={4} md={4} sm={12} className="mb-3">
                <Form.Label className="edu-label">Branch</Form.Label>
                <SelectDropDown
                  name="branchId"
                  placeholderName="Select Branch"
                  options={branchArr}
                  stateData={branchArr.find((opt) => String(opt.value) === String(this.state.branchId)) || null}
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                />
              </Form.Group>

              <Form.Group as={Col} lg={4} md={4} sm={12} className="mb-3">
                <Form.Label className="edu-label">Class</Form.Label>
                <SelectDropDown
                  name="classId"
                  placeholderName="Select Class"
                  options={classArr}
                  stateData={classArr.find((opt) => String(opt.value) === String(this.state.classId)) || null}
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                />
              </Form.Group>

              {isStreamClass(this.state.classId) && (
                <Form.Group as={Col} lg={4} md={4} sm={12} className="mb-3">
                  <Form.Label className="edu-label">Stream</Form.Label>
                  <SelectDropDown
                    name="streamId"
                    placeholderName="Select Stream"
                    options={streamArr}
                    stateData={streamArr.find((opt) => String(opt.value) === String(this.state.streamId)) || null}
                    handleChange={this.handleSelectChange}
                    isClearable={false}
                  />
                  {this.state.streamIdError && (
                    <div className="edu-error">{this.state.streamIdError}</div>
                  )}
                </Form.Group>
              )}

              <Form.Group as={Col} lg={4} md={4} sm={12} className="mb-3">
                <Form.Label className="edu-label">Section</Form.Label>
                <SelectDropDown
                  name="sectionId"
                  placeholderName="Select Section"
                  options={sectionArr}
                  stateData={sectionArr.find((opt) => String(opt.value) === String(this.state.sectionId)) || null}
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                />
                {this.state.sectionIdError && (
                  <div className="edu-error">{this.state.sectionIdError}</div>
                )}
              </Form.Group>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Update Student Password</Form.Label>
                <div style={{ position: "relative" }}>
                  <Form.Control
                    className="edu-input"
                    type={this.state.showStudentPassword ? "text" : "password"}
                    name="studentPassword"
                    placeholder="Enter password"
                    value={this.state.studentPassword}
                    onChange={this.handleInputChange}
                    style={{ paddingRight: "40px" }}
                  />
                  <i
                    className={this.state.showStudentPassword ? "far fa-eye-slash" : "far fa-eye"}
                    onClick={() => this.setState({ showStudentPassword: !this.state.showStudentPassword })}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6b7280",
                      zIndex: 10,
                      fontSize: "14px"
                    }}
                  />
                </div>
                {this.state.studentPasswordError && (
                  <div className="edu-error">{this.state.studentPasswordError}</div>
                )}
              </Form.Group>
            </Row>
          </div>

          {/* CARD 2: Parent Details */}
          <div className="edu-details-card">
            <div className="edu-details-card__header">
              <h5 className="edu-details-card__title">
                <i className="fas fa-user-friends"></i> Parent Details
              </h5>
            </div>

            <Row>
              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Father's Name</Form.Label>
                <Form.Control
                  className="edu-input"
                  type="text"
                  name="fatherName"
                  placeholder="Enter father's name"
                  value={this.state.fatherName}
                  onChange={this.handleInputChange}
                />
              </Form.Group>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Father's Mobile</Form.Label>
                <Form.Control
                  className="edu-input"
                  type="number"
                  name="fatherPhone"
                  placeholder="Enter 10 digit mobile"
                  value={this.state.fatherPhone}
                  onChange={this.handleInputChange}
                />
                {this.state.fatherPhoneError && (
                  <div className="edu-error">{this.state.fatherPhoneError}</div>
                )}
              </Form.Group>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Mother's Name</Form.Label>
                <Form.Control
                  className="edu-input"
                  type="text"
                  name="motherName"
                  placeholder="Enter mother's name"
                  value={this.state.motherName}
                  onChange={this.handleInputChange}
                />
              </Form.Group>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Mother's Mobile</Form.Label>
                <Form.Control
                  className="edu-input"
                  type="number"
                  name="motherPhone"
                  placeholder="Enter 10 digit mobile"
                  value={this.state.motherPhone}
                  onChange={this.handleInputChange}
                />
                {this.state.motherPhoneError && (
                  <div className="edu-error">{this.state.motherPhoneError}</div>
                )}
              </Form.Group>

              <Form.Group as={Col} lg={4} md={6} sm={12} className="mb-3">
                <Form.Label className="edu-label">Update Parent's Password</Form.Label>
                <div style={{ position: "relative" }}>
                  <Form.Control
                    className="edu-input"
                    type={this.state.showParentPassword ? "text" : "password"}
                    name="parentPassword"
                    placeholder="Enter password"
                    value={this.state.parentPassword}
                    onChange={this.handleInputChange}
                    style={{ paddingRight: "40px" }}
                  />
                  <i
                    className={this.state.showParentPassword ? "far fa-eye-slash" : "far fa-eye"}
                    onClick={() => this.setState({ showParentPassword: !this.state.showParentPassword })}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6b7280",
                      zIndex: 10,
                      fontSize: "14px"
                    }}
                  />
                </div>
                {this.state.parentPasswordError && (
                  <div className="edu-error">{this.state.parentPasswordError}</div>
                )}
              </Form.Group>
            </Row>
          </div>

        </Modal.Body>

        {/* FOOTER */}
        <Modal.Footer className="edu-modal-footer">

          <button
            className="edu-save-btn"
            onClick={this.handleFormSubmit}
            disabled={this.state.isSubmitting}
          >
            {this.state.loadingSpinner === 1 ? (
              <>
                <span className="spinner-border spinner-border-sm"></span>
                &nbsp; Saving...
              </>
            ) : (
              <>
                <i className="fas fa-save"></i>
                &nbsp; Save Changes
              </>
            )}
          </button>

        </Modal.Footer>

      </Modal>

    );
  }
}

export default EditDetailsModal;
